// extracted by mini-css-extract-plugin
module.exports = {"container":"mobileViewCardDetailsItem_container__3excZ"};